import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Home from '@/pages/Home'
import Contacts from '@/pages/Contacts'
import Products from '@/pages/Products'
import Product from '@/pages/Product'
import Shops from '@/pages/Shops'
import Blog from '@/pages/Blog'
import Post from '@/pages/Post'
// import Two from '@/pages/Two'
// import Tri from '@/pages/Tri'

export default new VueRouter ({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'Home',
			component: Home
		},
		{
			path: '/contacts',
			name: 'Contacts',
			component: Contacts
		},
		{
			path: '/products',
			name: 'Products',
			component: Products
		},
		{
			path: '/product/:id',
			props: true,
			name: 'Product',
			component: Product
		},
		{
			path: '/shops',
			name: 'Shops',
			component: Shops
		},
		{
			path: '/blog',
			name: 'Blog',
			component: Blog
		},
		{
			path: '/post/:id',
			props: true,
			name: 'Post',
			component: Post
		},
		// {
		// 	path: '/two',
		// 	name: 'two',
		// 	component: Two
		// },
		// {
		// 	path: '/tri',
		// 	name: 'tri',
		// 	component: Tri
		// }
	]
})